(function() {
  'use strict';

  angular.module('cfn').directive('cfnReferenceBox', cfnReferenceBox);

  cfnReferenceBox.$inject = ['$rootScope'];
  function cfnReferenceBox($rootScope) {
    var template =
      '<div>' +
      '   <table width="100%">' +
      '   <tr> <td><div  class="referenceBox"><table class="subElement" width="100%">' +
      '       <tr><td width="100%" nowrap="nowrap" style="">' +
      '				<span ng-show="field">{{nameField}}</span>' +
      '           </td>' +
      '           <td><div ng-show="!readonly">' +
      '               <cfn-select-reference class="imgOnly" result="result" service-param="{{serviceParam}}" pathExt="{{pathExt}}" title="{{title}}" multiselect="{{multiselect}}" onselect="onselect()" type="{{type}}" popover-path="{{popoverPath}}">' +
      '                   <img src="img/bicons/black/choose.png"/>' +
      '               </cfn-select-reference>' +
      '      </div> </td><td ng-show="!readonly&&field.id">' +
      '            <button type="button" class="btn imgOnly" ng-show="field!=undefined" ng-click="clear()">' +
      '               <span class="farmnet-delete" />' +
      '            </button>' +
      '       </td>' +
      '       </tr>' +
      '   </table>' +
      '   </div></td><td ng-show="jump==\'true\'">' +
      '            <button type="button" class="btn imgOnly" ng-show="field!=undefined" ng-click="jumpTo()">' +
      '               <img src="img/bicons/black/forth.png"/>' +
      '            </button>' +
      '   </td></tr>' +
      '   </table>' +
      '</div>';

    return {
      restrict: 'E',
      scope: {
        nameField: '=',
        field: '=',
        resultFunc: '&',
        resultTargetObject: '=?',
        change: '&',
        title: '@',
        multiselect: '@',
        onselect: '&',
        type: '@',
        popoverPath: '@',
        serviceParam: '@',
        pathExt: '@',
        readonly: '=',
        resultParam: '@',
        jump: '@'
      },
      template: template,
      link: link
    };

    function link(scope, element, attrs) {
      element.click(function(event) {
        if (!scope.readonly) {
          // if the element is no button in the first place, the element was a click on the background
          if (
            !(
              $(event.target).is(':button') ||
              $(event.target)
                .parent()
                .is(':button')
            )
          ) {
            ang.callAfter(function() {
              // we need to leave the angular scope because the click triggers an angular scope itself
              element.find('.open button').trigger('click');
            });
          }
        }
      });
      scope.jumpTo = function() {
        var goBack = ang.getInParents(scope, 'goBackToCore');
        if (goBack) {
          console.debug('jump to ', scope.type, scope.field);
          goBack(scope.type, scope.field.id);
        } else {
          console.debug('jump go to ', scope.field, scope.type);
          $rootScope.goto('/core/' + scope.type + '/' + scope.field.id);
        }
      };
      scope.result = function(ob) {
        var resultFunc = scope.resultFunc();
        if (resultFunc) {
          resultFunc(ob, scope.resultParam);
          scope.change();
        } else {
          if (Object.keys(ob).length === 0) scope.resultTargetObject = null;
          else scope.resultTargetObject = ob;

          scope.change();
        }
      };
      scope.clear = function() {
        if (scope.resultFunc()) {
          scope.resultFunc()({}, scope.resultParam);
        } else if (scope.onselect()) {
          scope.onselect()([]);
        }
        scope.resultTargetObject = null;
        scope.change();
      };
      if (scope.resultFunc()) {
        scope.result = function(ob) {
          scope.resultFunc()(ob, scope.resultParam);
        };
      }
    }
  }
})();
